<template>
  <div class="animation-wrapper">
    <transition
      appear
      @before-enter="beforeEnter"
      @enter="enter"
      :css="false">
      <div class="position-fixed" style="z-index: -10;">
        <PeppersBackground></PeppersBackground>
      </div>
    </transition>
  </div>
</template>

<script>
    import Velocity from 'velocity-animate'
    import PeppersBackground from '@shared/components/PeppersBackground'

    export default {
    name: 'AnimatedBackground',
    components: { PeppersBackground },
    methods: {
      beforeEnter (el) {
        el.style.opacity = 0
        el.style.rotate = '5deg'
      },
      enter (el, done) {
        Velocity(
          el, // element to animate
          {
            opacity: 1,
            translateZ: 10,
            rotateZ: '5deg'
          }, // new style rules
          {
            duration: 10000,
            easing: 'easeOutCubic'
          } // define how transition happens
        )
        Velocity(
          el, // element to animate
          {
            opacity: 0,
            translateZ: -10,
            rotateZ: '-5deg'
          }, // new style rules
          {
            duration: 10000,
            easing: 'easeInCubic'
          } // define how transition happens and complete it
        )
        Velocity(
          el, // element to animate
          {
            opacity: 1,
            translateZ: 50,
            rotateZ: '-15deg'
          }, // new style rules
          {
            duration: 10000,
            easing: 'easeOutCubic'
          } // define how transition happens
        )
        Velocity(
          el, // element to animate
          {
            opacity: 0,
            translateZ: -50,
            rotateZ: '15deg'
          }, // new style rules
          {
            duration: 10000,
            easing: 'easeInCubic',
            complete: this.enter
          } // define how transition happens and complete it
        )
      }
    }
  }
</script>

<style scoped>
.animation-wrapper {
  perspective-origin: 100% 50%;
  perspective: 100px;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  position: fixed;
}
</style>
